// Template: Add your feature flag here
// export const YOUR_FLAG_NAME_COOKIE_KEY = 'yourFlagName';
export const USER_FEEDBACK = 'user-feedback';
export const MATCHA_ACCOUNT = 'matcha-account';

/// List of supported feature flags.
export const SUPPORTED_FEATURE_FLAGS: string[] = [
  // feature flags here
  // YOUR_FLAG_NAME_COOKIE_KEY,
  USER_FEEDBACK,
  MATCHA_ACCOUNT,
];
